import React from 'react';
import {useSelector} from 'react-redux';

import {Store, Course} from 'src/types/store';

import EmptyInstitutionSection from './empty-institution-section';
import SchoolTable from './school-table';

interface Props {
  institutionId: string;
  courseGroups: Record<string, Course[]>;
  classYear: string;
  onAddClick: () => void;
}

const SchoolSection = ({institutionId, courseGroups, classYear, onAddClick}: Props) => {
  const institution = useSelector((state: Store) => state.institutions[institutionId]);
  const coursesByGradeSettings = Object.keys(courseGroups);

  if (!institution) return null;

  if (coursesByGradeSettings.length === 1 && Object.values(courseGroups)[0]?.length === 0) {
    return (
      <EmptyInstitutionSection
        key={institution._id}
        name={institution.name}
        classYear={classYear}
        onAddClick={onAddClick}
      />
    );
  }

  return <SchoolTable schoolName={institution.name} courseGroups={courseGroups} />;
};

export default SchoolSection;
